/**
 * Build initials from a display name (e.g. "Jane Doe" -> "JD", "Madonna" -> "MA").
 */
export function deriveInitialsFromName(name) {
	const trimmed = (name || "").trim();
	if (!trimmed) return "";
	const parts = trimmed.split(/\s+/).filter(Boolean);
	const letter = (ch) => {
		if (!ch) return "";
		const u = ch.toUpperCase();
		return /[A-Z0-9]/.test(u) ? u : "";
	};
	if (parts.length === 1) {
		const w = parts[0].replace(/[^A-Za-z0-9]/g, "");
		if (!w) {
			const c0 = letter(parts[0][0]);
			const c1 = letter(parts[0][1] || "");
			return (c0 + c1).toUpperCase();
		}
		if (w.length === 1) return w.toUpperCase();
		return w.slice(0, 2).toUpperCase();
	}
	const first = letter(parts[0][0]);
	const last = letter(parts[parts.length - 1][0]);
	return (first + last).toUpperCase();
}

/**
 * External eSignature app: best-effort display name from `esignature` localStorage.
 */
export function getSignerDisplayNameFromStorage() {
	try {
		const raw = localStorage.getItem("esignature");
		if (!raw) return "";
		const es = JSON.parse(raw);
		return (
			es.fullName ||
			es.name ||
			es.displayName ||
			es.userName ||
			(es.email ? String(es.email).split("@")[0] : "") ||
			""
		);
	} catch {
		return "";
	}
}
